module.exports = __webpack_public_path__ + "img/oven.be5030ca.webp";